'use strict';

function LoanApplicationEmployment() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];

  this._callbacks = {};

  this._$classes = {
    employmentForm: '.js--loan-application-employment-form',
    employmentName: '.js--employment-name',
    employerPhone: '.js--employer-phone',
    employerPhoneExt: '.js--employer-phone-ext',
    occupation: '.js--occupation',
    nextBtn: '.js--next',
    prevBtn: '.js--previous'
  };

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._$node = $(this.node);
    this._$form = this._$node.find(this._$classes.employmentForm);
    this._$employmentNameInput = this._$node.find(this._$classes.employmentName);
    this._$employmentPhoneInput = this._$node.find(this._$classes.employerPhone);
    this._$employmentPhoneExtInput = this._$node.find(this._$classes.employerPhoneExt);
    this._$occupationInput = this._$node.find(this._$classes.occupation);
    this._$nextBtn = this._$node.find(this._$classes.nextBtn);
    this._$prevBtn = this._$node.find(this._$classes.prevBtn);

    // Reset Data for when users type data and exits the flow
    this._loanApplications[0].resetData();

    this._setupForm();
    this._setupEventHandlers();
    this._pushAnalytics();
    this._removeProgressLoader();
  };

  this.destroy = function () {
    if (this._teardownFn) {
      this._teardownFn();
    }
    this._super();
  };

  this._setupEventHandlers = function () {
    this._$prevBtn.on('click', function () {
      $('#LoanApplicationTray').mogo()._loanAppGoToPreviousStep();
    });
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._setupForm = function () {
    var canUpdate = this._loanApplications[0].hasSubmittedEmployment();
    var employerName = this._loanApplications[0].getEmployerName();
    var employerPhone = this._loanApplications[0].getEmployerPhoneNumber();
    var jobTitle = this._loanApplications[0].getJobTitle();
    var modelPath = this._loanApplications[0].getModelPath();

    /*
      The application for a level up offer can be partially filled.
      The employment object hosts both employment AND income step information.
      This means that BE returns update_loan_application employment relink
      if let say first_payment_date in the income step is filled out.
       Inserts data-action link to form
    */

    if (!canUpdate && this.presenter.hasAction(modelPath + '.employment.update_loan_application_employment') || employerName || employerPhone || jobTitle) {
      this._teardownFn = this._loanApplications[0].updateEmployment(this._$form[0], {
        success: this._onUpdateEmploymentSuccess.bind(this),
        failure: this._onUpdateEmploymentFailure.bind(this)
      });
    } else {
      this._teardownFn = this._loanApplications[0].createEmployment(this._$form[0], {
        success: this._onUpdateEmploymentSuccess.bind(this),
        failure: this._onUpdateEmploymentFailure.bind(this)
      });
    }
  };

  // On complete update, users should be directed back to the review page
  this._onUpdateEmploymentSuccess = function (data, response, request) {
    this._submitAnalyticsForm();
    $('#LoanApplicationTray').mogo()._loanAppGoToNextStep();
  };

  this._submitAnalyticsForm = function () {
    if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
      this.analytics.forcePushEvent('form-submit', {
        FormID: ['Money-Form Submission-Employment Information Edit-null-Form']
      });
    } else {
      this.analytics.pushEvent('form-submit', {
        FormID: ['Money-Form Submission-Employment Information-null-Form'],
        LTV: [this.presenter.getModelProperty('account.life_time_value')]
      });
    }
  };

  this._pushAnalytics = function () {
    var url = window.location.pathname + (this.presenter.getModelProperty('money._loanApplicationEdit') === true ? '-edit' : '');

    this.analytics.forcePushEvent('virtual-page-view', {
      Page: [url]
    });
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._onUpdateEmploymentFailure = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });

      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.key));
      });
    }
  };
}